import React, { useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";

import ModalLoading from "../../components/modalLoading/ModalLoading";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import validatesNotNull from "../../utils/validatesNotNull";
import { getProducts } from "../../repositories/productRepository";
import { getLocalizationsPointAccess } from "../../repositories/localizationPointAccessRepository";
import { createVideo, editVideo } from "../../repositories/videoRepository";
import { notify } from "../../utils/notify";

import { FormControlLabel, GridCustom } from "./style/Videos";

const DialogVideo = (props) => {
  const { editData, open, handleClose } = props;

  const [id, setId] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [url, setUrl] = useState("");
  const [idProduto, setIdProduto] = useState(null);
  const [idLocalizacaoPontoAcesso, setIdLocalizacaoPontoAcesso] =
    useState(null);
  const [ativo, setAtivo] = useState(true);
  const [optionsProducts, setOptionsProducts] = useState([]);
  const [optionsLocalizationsPointAccess, setOptionsLocalizationsPointAccess] =
    useState([]);

  const [loading, setLoading] = useState({});
  const [errors, setErrors] = useState({});

  // busca opções select prdutos e localizações
  useEffect(() => {
    const fetchData = async () => {
      setLoading((prev) => ({
        ...prev,
        products: true,
        localizationsPointAccess: true,
      }));

      try {
        const { data: response } = await getProducts();
        if (response.data) {
          setOptionsProducts(response.data);
        }
        setLoading((prev) => ({ ...prev, products: false }));
      } catch (error) {
        console.error("ERROR: DialogVideo.fetchData", error);
        setLoading((prev) => ({ ...prev, products: false }));
      }

      try {
        const { data: response } = await getLocalizationsPointAccess();
        if (response.data) {
          setOptionsLocalizationsPointAccess(response.data);
        }
        setLoading((prev) => ({ ...prev, localizationsPointAccess: false }));
      } catch (error) {
        console.error("ERROR: DialogVideo.fetchData", error);
        setLoading((prev) => ({ ...prev, localizationsPointAccess: false }));
      }
    };

    fetchData();
  }, []);

  // autocomplete caso edit
  useEffect(() => {
    if (editData) {
      setId(editData.Id);
      setTitulo(editData.Titulo);
      setUrl(editData.Url);
      setAtivo(editData.Ativo);
      if (optionsProducts.length > 0) {
        setIdProduto(
          optionsProducts.find((element) => element.Id === editData.IdProduto)
        );
      }
      if (optionsLocalizationsPointAccess.length > 0) {
        setIdLocalizacaoPontoAcesso(
          optionsLocalizationsPointAccess.find(
            (element) => element.Id === editData.IdLocalizacaoPontoAcesso
          )
        );
      }
    }
  }, [editData, optionsProducts, optionsLocalizationsPointAccess]);

  const submitVideo = async (e) => {
    setLoading((prev) => ({ ...prev, saving: true }));
    try {
      const resultValidation = validatesNotNull([
        { value: titulo, key: "title" },
        { value: url, key: "url" },
        { value: idProduto, key: "products" },
        { value: idLocalizacaoPontoAcesso, key: "localizationsPointAccess" },
      ]);

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading((prev) => ({ ...prev, saving: false }));
      }

      let body = {
        Titulo: titulo,
        Ativo: ativo,
        Url: url,
        IdProduto: idProduto.Id,
        IdLocalizacaoPontoAcesso: idLocalizacaoPontoAcesso.Id,
      };

      const { data: returnVideo } = id
        ? await editVideo({ id, body })
        : await createVideo({ body });

      if (!returnVideo.success) {
        notify("Falha ao salvar Vídeo.", true, "error");
      } else {
        notify("Vídeo salvo com sucesso.", true, "info");
        handleClose(true);
      }

      return setLoading((prev) => ({ ...prev, saving: false }));
    } catch (error) {
      console.error("ERROR: DialogVideo.save", error);
      return setLoading((prev) => ({ ...prev, saving: false }));
    }
  };

  return (
    <>
      {loading.saving && <ModalLoading loading={loading.saving} />}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-video"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="dialog-video">Cadastro de Vídeo</DialogTitle>
        <DialogContent>
          <Grid
            container
            alignItems="center"
            justify="center"
            className="fadeInDown"
            spacing={2}
          >
            <Grid item lg={10} md={10} sm={10} xs={10}>
              <TextFieldCustom
                maxLength={255}
                label="Título *"
                type="text"
                value={titulo}
                setValue={setTitulo}
                error={errors.title}
              />
            </Grid>
            <GridCustom item lg={2} md={2} sm={2} xs={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={ativo}
                    onChange={() => setAtivo((e) => !e)}
                    name={ativo ? "Ativo" : "Inativo"}
                    color="primary"
                  />
                }
                label={ativo ? "Ativo" : "Inativo"}
              />
            </GridCustom>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextFieldCustom
                maxLength={255}
                label="Vídeo Url *"
                type="text"
                value={url}
                setValue={setUrl}
                error={errors.url}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12}>
              <SelectCustom
                loading={loading.products}
                label="Produto *"
                keyObject="Descricao"
                value={idProduto}
                setValue={setIdProduto}
                error={errors.products}
                optionsList={optionsProducts}
              />
            </Grid>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <SelectCustom
                loading={loading.localizationsPointAccess}
                label="Localização *"
                keyObject="Descricao"
                value={idLocalizacaoPontoAcesso}
                setValue={setIdLocalizacaoPontoAcesso}
                error={errors.localizationsPointAccess}
                optionsList={optionsLocalizationsPointAccess}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancelar
          </Button>
          <Button onClick={submitVideo} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogVideo;
